import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { BankAccountForm } from '../Forms';
import { Text1 } from '../../../styles';


const AddBankAccountModal = (props) => {
    
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                {`${props.account.is_edit ? "Update" : "Add"} Bank Account`}
            </Text1>
        )
    };
    return (
        <EaseModal
            width={550}
            title={false}
            visible={props.visible}
            onCancel={props.toggleBankAccountModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <BankAccountForm
                account={props.account}
                onSubmit={props.saveBankAccount}
                loading={props.loading}
            />
        </EaseModal>
    )
};

AddBankAccountModal.defaultProps = {
    contact: {}
};

export { AddBankAccountModal };